import "../../Css/NewHome/WeddingCategory.css";
import { NavLink } from "react-router-dom";
import SectionComp from "../SectionComp";
import { useEffect, useState } from "react";
import { get } from "../../services/ApiRouting";
import venues_demo_image from "../../Images/venues/venues_demo_image.jpg";

const WeddingCategory = () => {
  const [events, setEvents] = useState([]);
  console.log("events",events)
  const fetchData = async () => {
    const response = await get("communities?type=event");
    setEvents(response.data);
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(dbounce);
  }, []);

  return (
    <div>
      <section className="section new-home-wedding-category-section">
        <div className="container">
          <SectionComp
            title={"Whatever the Event, We’ve Got You Covered"}
            para={
              "Whether it’s love, joy, or business — we help make every event a success."
            }
          />
          <div className="new-home-wedding-category-section-details-main-con">
            <div className="row">
              <div className="col-lg-3">
                <NavLink to={`/vendors?event=${events[0]?.slug}`}>
                  <div className="new-home-wedding-category-card-main-con-first radiusLeft ">
                    <img
                      src={events[0]?.image || venues_demo_image}
                      alt={events[0]?.name}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = venues_demo_image;
                      }}
                    />
                    <div className="new-home-wedding-category-card-main-text-con new-home-wedding-category-card-main-first-text-con">
                      <h3>{events[0]?.name}</h3>
                    </div>
                  </div>
                </NavLink>
              </div>

              <div className="col-lg-6">
                <div className="new-home-wedding-category-section-mid-main-con">
                  <NavLink to={`/vendors?event=${events[1]?.slug}`}>
                    <div className="new-home-wedding-category-section-mid-image-first-con ">
                      <img
                        src={events[1]?.image || venues_demo_image}
                        alt={events[1]?.name}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = venues_demo_image;
                        }}
                      />
                      <div className="new-home-wedding-category-card-main-text-con new-home-wedding-category-card-main-first-text-con">
                        <h3>{events[1]?.name}</h3>
                      </div>
                    </div>
                  </NavLink>
                  <NavLink to={`/vendors?event=${events[2]?.slug}`}>
                    <div className="new-home-wedding-category-section-mid-image-second-con radiusBottom">
                      <img
                        src={events[2]?.image || venues_demo_image}
                        alt={events[2]?.name}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = venues_demo_image;
                        }}
                      />
                      <div className="new-home-wedding-category-card-main-text-con new-home-wedding-category-card-main-first-text-con">
                        <h3>{events[2]?.name}</h3>
                      </div>
                    </div>
                  </NavLink>
                </div>
              </div>

              <div className="col-lg-3">
                <NavLink to={`/vendors?event=${events[3]?.slug}`}>
                  <div className="new-home-wedding-category-card-main-con-fourth radiusRight">
                    <img
                      src={events[3]?.image || venues_demo_image}
                      alt={events[3]?.name}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = venues_demo_image;
                      }}
                    />
                    <div className="new-home-wedding-category-card-main-text-con new-home-wedding-category-card-main-first-text-con">
                      <h3>{events[3]?.name}</h3>
                    </div>
                  </div>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WeddingCategory;
